import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-23af5972")

_pushScopeId("data-v-23af5972")
const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "flex flex--v flex--valign-c flex--gap-40" }, [
  /*#__PURE__*/_createVNode("div", { class: "flex flex--v flex--valign-c flex--gap-10" }, [
    /*#__PURE__*/_createVNode("span", { class: "text text--size-18 text--primary-b text--center text--semi-bold" }, "Herausgeberin"),
    /*#__PURE__*/_createVNode("span", { class: "text text--size-18 text--primary-b text--center text--less-gap" }, "Stadt Oldenburg (Oldb)"),
    /*#__PURE__*/_createVNode("span", { class: "text text--size-18 text--primary-b text--center text--less-gap" }, "Der Oberbürgermeister"),
    /*#__PURE__*/_createVNode("span", { class: "text text--size-18 text--primary-b text--center text--less-gap" }, "26105 Oldenburg")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "flex flex--v flex--valign-c flex--gap-10" }, [
    /*#__PURE__*/_createVNode("span", { class: "text text--size-18 text--primary-b text--center text--less-gap" }, "Verantwortlich im Sinne von § 5 Telemediengesetz (TMG) und § 55 Rundfunkstaatsvertrag (RStV):"),
    /*#__PURE__*/_createVNode("span", { class: "text text--size-18 text--primary-b text--center text--less-gap" }, "Stadt Oldenburg (Oldb), Amt für Schule und Bildung"),
    /*#__PURE__*/_createVNode("span", { class: "text text--size-18 text--primary-b text--center text--less-gap" }, "Bergstraße 25, 26122 Oldenburg (Oldb)")
  ])
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_MainPage = _resolveComponent("MainPage")

  return (_openBlock(), _createBlock(_component_MainPage, {
    title: "Impressum",
    gap: true
  }, {
    default: _withId(() => [
      _hoisted_1
    ]),
    _: 1
  }))
})